export default __webpack_public_path__ + "static/media/exportIconoff.3ffc1c80.svg";